import React from "react";
import { StyleSheet, Text as DefaultText } from "react-native";
import { View } from "@components/atoms/Themed";
import Icon from "@components/atoms/Icon";
import Colors from "@constants/Colors";

type Props = {
  count: number;
  size?: number;
  color?: string;
};

export default function NotificationBadge({
  count,
  size = 24,
  color,
}: Props): JSX.Element {
  const display = count > 99 ? "99+" : `${count}`;
  return (
    <View style={styles.container}>
      <Icon color={color} name="bell" size={size} />
      {count > 0 && (
        <View style={styles.badge}>
          <DefaultText style={styles.badgeText}>{display}</DefaultText>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 28,
    height: 28,
    alignItems: "center",
    justifyContent: "center",
  },
  badge: {
    position: "absolute",
    top: -4,
    right: -8,
    minWidth: 16,
    height: 16,
    paddingHorizontal: 4,
    borderRadius: 8,
    backgroundColor: Colors.orange,
    alignItems: "center",
    justifyContent: "center",
  },
  badgeText: {
    color: Colors.white,
    fontSize: 10,
    lineHeight: 14,
    fontWeight: "700",
  },
});
